import React from "react";

const Blogs = () => {
  return (
    <div className="blog-container">
      <h3 className="font-color pb-3">Question-1: JavaScript vs Node js.</h3>
      <p>
        Answer: JS is a programming anguage that used for writing scripts on the
        browser. It is basically used on the client-side means in front-end
        development. It is capable enough to add and play with the DOM. <br />
        On the other hand, Node js. is js runtime environment. Mostly used in
        server side means in back-end development. doesn't have the capacity to
        add html tags.
      </p>

      <h3 className="font-color pb-3">
        Question-2: When should you use Nodejs and when should you use mongoDB?
      </h3>
      <p>
        Answer: Nodejs is a Javascript engine that one can write any application
        as they want with (by programming in the Javascript language). It runs
        Javascript code. Most commonly, it is used to build servers that can
        respond to web requests.
        <br />
        Any project needs a programming environment and a runtime library that
        offers basic programming tools/support and can compile and/or interpret
        the code. Nodejs is such as tool for the Javascript programming
        language. So, if we want to write some kind of stand-alone program or
        server in Javascript, then we can use nodejs for it.
        <br />
        MongoDB offers an API library that runs within a Nodejs application to
        give us programmatic access to MongoDB so that we can create databases
        and then add, query, update or delete data from the MongoDB database.
        <br />
        So when application needs the ability to persistently store data in a
        way that we can efficiently query or update it later, then we would
        typically use some form of database. There are dozens of popular
        databases. MongoDB is one such database.
      </p>

      <h3 className="font-color pb-3">
        Question-3: Differences between SQL and noSQL databases.
      </h3>
      <p>
        Answer: SQL databases are vertically scalable. they are table-based.
        Mostly better for multi-row transactions.
        <br />
        NoSQL databases are horizontally scalable. they do stores document,
        key-value, graph, or wide-column. NoSQL is better for unstructured data
        like documents or JSON.
      </p>
    </div>
  );
};

export default Blogs;
